const BASE = '/v1/users';

export default (instance) => ({
  /**
   * Upsert the current user's local profile (name/email) and grant them
   * default permissions. Called once per session after login so users
   * invited to an org actually show up in operator/station assignment lists.
   * @param {{ email: string, displayName: string }} data
   */
  syncProfile: (data) => instance.post(`${BASE}/sync-profile`, data),

  /**
   * Unassign the current user from all stations in their current org.
   * Call right after leaving that org, before the access token is refreshed.
   */
  leaveOrg: () => instance.post(`${BASE}/leave-org`),

  /** The current user's effective permission keys (role permissions + any direct extra grants). */
  getMyPermissions: () => instance.get(`${BASE}/permissions`),

  /** Every active user in the caller's org, with their current role. Admin-only. */
  getOrgUsers: () => instance.get(BASE),

  /** Change a user's role. Admin-only. */
  setUserRole: (userId, roleId) => instance.put(`${BASE}/${userId}/role`, { roleId })
});
